import { BaseController } from '~/utils/base-controller';

export default class extends BaseController {
	/* @ngInject */
	constructor(
		/** @type {Knitiv.Angular.RouteParams} */
		$routeParams,
		/** @type {Knitiv.Angular.Injector} */
		$injector,
	) {
		super($injector);

		this.src = `/form/${$routeParams.formId}`;
		this.params = {};
	}
}
